export default ({ to, from, next }) => {
    if (!localStorage.getItem('userToken')) {
        next('/')
        
        return false;
    }

    next()
}